import { mergeClasses } from '@/utils';

export const Skeleton = ({ className, ...props }: React.ComponentProps<'div'>) => {
  return (
    <div
      data-slot="skeleton"
      className={mergeClasses('bg-neutral-4 animate-pulse', className)}
      {...props}
    />
  );
};
